import { Form, FormSelect, FormTextField, getIn, useFormikContext } from '../Formik/forms'

import MenuItem from '@mui/material/MenuItem'
import Stack from '@mui/material/Stack'

import useClientMetadata from 'hooks/useClientMetadata'
import { PAYOUT_LABEL_MAP } from 'components/AllocationsTable/AllocationsTable'
import Chip from '@mui/material/Chip'
import Typography from '@mui/material/Typography'
import { useEffect } from 'react'

const CAP_TYPE_OPTIONS = [
  {
    value: true,
    text: 'Soft Cap',
    hint: '(Estimated target for projection math)',
    isDefault: true
  },
  {
    value: false,
    text: 'Hard Cap',
    hint: '(Stops traffic when reached)',
    isDefault: false
  }
]

function AddClientCampaignFormInputs({programGroupsResource, isNewCampaign, clientId}) {
  const { clientCampaignCustomAttributes } = useClientMetadata([clientId])
  const { values, setFieldValue } = useFormikContext()

  const isCPE = getIn(values, 'payout') === 'cost_per_enroll'
  const isVCPL = getIn(values, 'payout') === 'variable_cost_per_lead'

  {/* Force softCaps input to true when payout is set to vCPL, it's the only accepted option */}
  useEffect(() => {
    if(isVCPL) {
      setFieldValue('softCaps', true)
    }
  }, [isVCPL, setFieldValue])

  return (
    <Stack spacing={2} mt={2}>
      <FormSelect name="programGroupId" label="Program Group" disabled={!isNewCampaign}>
        {programGroupsResource.get()?.map(programGroup => (
          <MenuItem value={programGroup.id} key={programGroup.id}>{programGroup.attributes.description}</MenuItem>
        ))}
      </FormSelect>
      <FormSelect name="payout" label="Lead Pricing" disabled={!isNewCampaign}>
        {Object.entries(PAYOUT_LABEL_MAP)
          .filter(([key]) => isCPE ? true : key !== 'cost_per_enroll')
          .map(([value, text]) => (
            <MenuItem value={value} key={value}>{text}</MenuItem>
          )
        )}
      </FormSelect>
      <FormTextField name="name" label="Name"/>
      {/* Disable softCaps for vCPL campaigns, campaign controller always overrides to true in this case */}
      <FormSelect key={isVCPL ? 'softCaps-vcpl' : 'softCaps-non-vcpl'} name="softCaps" label="Cap Type" disabled={isVCPL}>
        {CAP_TYPE_OPTIONS.map((option, index) => (
          // Loosen type expectations to allow boolean - using string 'true' / 'false' is not supported by Form
          <MenuItem value={option.value as unknown as string} key={index}>
            <Stack direction={'row'} sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
              <Stack direction={'row'} gap={1} sx={{ alignItems: 'baseline' }}>
                {option.text}
                <Typography variant='subtitle1'>
                  {option.hint}
                </Typography>
              </Stack>
              {option.isDefault &&
                <Chip label='Default' />
              }
            </Stack>
          </MenuItem>
        ))}
      </FormSelect>
      {clientCampaignCustomAttributes.map((name, index) => (
        <FormTextField name={`customAttributes[${name}]`} label={name} key={index} />
      ))}
    </Stack>
  )
}

export default function AddClientCampaignForm({contract, clientCampaign, programGroupsResource, onSave, isNewCampaign, clientId}) {

  return (
    <Form
      resource={clientCampaign}
      relatedResource={isNewCampaign ? contract : undefined}
      onSave={onSave}
      redirectAfterSave={false}
      promptOnNavigate={false}
      relationshipIds={['programGroupId']}
    >
      <AddClientCampaignFormInputs programGroupsResource={programGroupsResource} isNewCampaign={isNewCampaign} clientId={clientId} />
    </Form>
  )
}
